// extracted by mini-css-extract-plugin
module.exports = {"footer":"ChatFooter_footer__2KPBK","footerTextarea":"ChatFooter_footerTextarea__Xxqu0","footerSendBtn":"ChatFooter_footerSendBtn__XOANW"};